import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Team → Incentives (C-16 S1, GLE-8408). The page ships dark, so the entry
 * waits for `manage/me.features.incentives`, inside a window from the release
 * to release + 14 days, and each LGA and Admin sees it on two ET days from
 * the switch-on (the default day cap, C16-D425/D426). Callers' Rewards entry
 * lives with the Rewards source (modules/rewards/lib/launch.ts).
 */
export const INCENTIVES_2026_10_27: WhatsNewEntryI = {
  id: "2026-10-27-incentives",
  feature: "incentives",
  startsAt: "2026-10-27T04:00:00.000Z",
  endsAt: "2026-11-10T05:00:00.000Z",
  title: {
    [LGA]: "Incentives, under Team",
    [ADMIN]: "Incentives, under Team",
  },
  intro: {
    [LGA]: "Build and run contests for your callers right here.",
    [ADMIN]: "Build and run contests for every workspace right here.",
  },
  sections: [
    {
      id: "incentives",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.GIFT,
      title: "Team → Incentives",
      items: [
        "Create a contest: the prize, the goal, and who's in it (a workspace, some campaigns or chosen reps).",
        "Schedule it, preview the standings before it starts, and pause or end it any time.",
        "Every contest has live standings, and the Payout history tab lists what each one paid.",
      ],
      link: { label: "Open Incentives", href: Router.manageIncentives() },
    },
    {
      id: "incentive-callers",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.TROPHY,
      title: "What your callers see",
      items: [
        "Their contests under Performance → Rewards, with their standing.",
        "A bell when a contest starts, and one when they win.",
      ],
    },
  ],
};
